<template>
  <div class="stage-coupon">
    <div v-if="memberMsg.integral ==0">
      <div v-if="!memberMsg.cardList && !memberMsg.appointCardList">
        <div class="no-coupon">
          <p class="icon-box">
            <i class="iconfont icon-tishi1"></i>
          </p>
          <p>您当前还未有会员优惠信息，请先领取优惠券，或直接消费以获得会员积分。</p>
        </div>
      </div>
    </div>
    <div>
      <div v-if="(memberMsg.appointCardList ? memberMsg.appointCardList.length > 0 ? true : false : false) || (memberMsg.cardList ? memberMsg.cardList.length > 0 ? true : false : false)" class="N_box">
        <ul v-if="memberMsg.appointCardList ? memberMsg.appointCardList.length > 0 ? true : false : false" class="coupon-list ul">
          <li v-for="(item,index) in memberMsg.appointCardList" :key="index" @click="selectAppoint(item,index)">
            <div class="item" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_bg_color' : ''">
              <div :class="selectAppointIndex === index&&selectAppointFlag ? 'rightTopLabel_2' : 'rightTopLabel_1'">指定</div>
              <div v-if="item.cardType == 1" class="content" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_bd_color' : ''">
                <p class="contentOne" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_text_color' : ''">
                  <span class="two-t" v-text="item.discount"></span>
                  <span class="three-t">折</span>
                  <span class="four-t" v-text="'×'+item.count"></span>
                </p>
                <p class="contentTwo" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_bgText_color' : ''">
                  <samp>{{ item.title }}</samp>
                  <el-popover class="item" placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                    <div class="couponTitle">{{ item.title }}</div>
                    <p class="couponP">使用范围：美业</p>
                    <p class="couponP">优惠券类型：{{ item.cardType == 1 ? '折扣券' : '代金券' }}</p>
                    <p class="couponP">优惠券详情：{{ item.couponDetail }}</p>
                    <p class="couponP">已开启功能：{{ item.openDetail }}</p>
                    <p class="couponP">有效期：{{ item.startTime }}至{{ item.endTime }}</p>
                    <i slot="reference" class="iconfont">&#xe71a;</i>
                  </el-popover>
                </p>
                <label></label>
              </div>
              <div v-if="item.cardType == 2" class="content" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_bd_color' : ''">
                <p class="contentOne" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_text_color' : ''">
                  <span class="one-t">￥</span>
                  <span class="two-t" v-text="item.reduceCost"></span>
                  <!-- <span class="three-t">免减券</span> -->
                  <span class="four-t" v-text="'×'+item.count"></span>
                </p>
                <p class="contentTwo" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_bgText_color' : ''">
                  <samp>{{ item.title }}</samp>
                  <el-popover class="item" placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                    <div class="couponTitle">{{ item.title }}</div>
                    <p class="couponP">使用范围：美业</p>
                    <p class="couponP">优惠券类型：{{ item.cardType == 1 ? '折扣券' : '代金券' }}</p>
                    <p class="couponP">优惠券详情：{{ item.couponDetail }}</p>
                    <p class="couponP">已开启功能：{{ item.openDetail }}</p>
                    <p class="couponP">有效期：{{ item.startTime }}至{{ item.endTime }}</p>
                    <i slot="reference" class="iconfont">&#xe71a;</i>
                  </el-popover>
                </p>
                <label></label>
              </div>
            </div>
            <div v-if="selectAppointIndex === index&&selectAppointFlag">
              <p class="tips">
                已选择
                <span v-text="'×'+hasSelectNumber"></span>
              </p>
            </div>
          </li>
        </ul>
        <ul v-if="memberMsg.cardList ? memberMsg.cardList.length > 0 ? true : false : false" class="coupon-list ul">
          <li v-for="(item,index) in memberMsg.cardList" :key="index" @click="selectCoupon(item,index)">
            <div class="item" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_bg_color' : ''">
              <div :class="selectCouponIndex === index&&selectCouponFlag ? 'rightTopLabel_2' : 'rightTopLabel_1'">通用</div>
              <div v-if="item.cardType == 1" class="content" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_bd_color' : ''">
                <p class="contentOne" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_text_color' : ''">
                  <span class="two-t" v-text="item.discount"></span>
                  <span class="three-t">折</span>
                  <span class="four-t" v-text="'×'+item.count"></span>
                </p>
                <p class="contentTwo" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_bgText_color' : ''">
                  <samp>{{ item.title }}</samp>
                  <el-popover class="item" placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                    <div class="couponTitle">{{ item.title }}</div>
                    <p class="couponP">使用范围：全场通用</p>
                    <p class="couponP">优惠券类型：{{ item.cardType == 1 ? '折扣券' : '代金券' }}</p>
                    <p class="couponP">优惠券详情：{{ item.couponDetail }}</p>
                    <p class="couponP">已开启功能：{{ item.openDetail }}</p>
                    <p class="couponP">有效期：{{ item.startTime }}至{{ item.endTime }}</p>
                    <i slot="reference" class="iconfont">&#xe71a;</i>
                  </el-popover>
                  <!-- <el-tooltip class="item" effect="light" placement="right-end">
                                    <div slot="content">
                                        <p>优惠券名称：{{item.title}}</p>
                                        <p>优惠券类型：{{item.cardType == 1 ? '折扣券' : '满减券'}}</p>
                                        <p v-if="item.cardType == 2">优惠券金额：{{item.reduceCost}}</p>
                                        <p>优惠券属性：仅支持线上使用</p>
                                        <p>使用条件：</p>
                                        <p>1、仅支持美容行业使用</p>
                                        <p v-if="item.cardType == 1">2、折扣优惠直接使用即可</p>
                                        <p v-if="item.cardType == 2">2、消费金额大于优惠券金额即可使用</p>
                                        <p>可用时间：{{item.startTime}}至{{item.endTime}}</p>
                                    </div>
                                    <i class="iconfont">&#xe71a;</i>
                                </el-tooltip> -->
                </p>
                <label></label>
              </div>
              <div v-if="item.cardType == 2" class="content" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_bd_color' : ''">
                <p class="contentOne" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_text_color' : ''">
                  <span class="one-t">￥</span>
                  <span class="two-t" v-text="item.reduceCost"></span>
                  <!-- <span class="three-t">免减券</span> -->
                  <span class="four-t" v-text="'×'+item.count"></span>
                </p>
                <p class="contentTwo" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_bgText_color' : ''">
                  <samp>{{ item.title }}</samp>
                  <el-popover class="item" placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                    <div class="couponTitle">{{ item.title }}</div>
                    <p class="couponP">使用范围：全场通用</p>
                    <p class="couponP">优惠券类型：{{ item.cardType == 1 ? '折扣券' : '代金券' }}</p>
                    <p class="couponP">优惠券详情：{{ item.couponDetail }}</p>
                    <p class="couponP">已开启功能：{{ item.openDetail }}</p>
                    <p class="couponP">有效期：{{ item.startTime }}至{{ item.endTime }}</p>
                    <i slot="reference" class="iconfont">&#xe71a;</i>
                  </el-popover>
                </p>
                <label></label>
              </div>
            </div>
            <div v-if="selectCouponIndex === index&&selectCouponFlag">
              <p class="tips">
                已选择
                <span v-text="'×'+hasSelectNumber"></span>
              </p>
            </div>
          </li>
        </ul>
        <div class="moreCoupon" @click="getMoreCoupon">更多优惠券</div>
      </div>

      <!-- <ul v-if="(memberMsg.fansCurrency !=0 && memberMsg.fansCurrency) || (memberMsg.integral !=0 && memberMsg.integral)" class="card-list ul"> -->
      <ul v-if="memberMsg.integral !=0 && memberMsg.integral" class="card-list ul">
        <!-- <li v-if="memberMsg.fansCurrency !=0 && memberMsg.fansCurrency" :class="selectFansCurrencyFlag?'avtive':''" @click="selectFansCurrency(memberMsg)">
          <div class="content">
            <div class="detail">
              <h1>
                <i class="iconfont" style="font-size: 20px;">&#xe615;</i>{{ memberMsg.fansCurrency }}<span>粉币</span>
              </h1>
              <p>( 粉币可抵扣{{ memberMsg.fenbiMoeny }}元 )</p>
            </div>
          </div>
          <p v-if="fenBiMsg.money!==0" class="tips">已抵扣{{ parseFloat(fenBiMsg.money).toFixed(2) }}元</p>
        </li> -->
        <li v-if="memberMsg.integral !=0 && memberMsg.integral" :class="selectIntegralFlag?'avtive':''" @click="selectIntegral(memberMsg)">
          <div class="content">
            <div class="detail">
              <h1>
                <i class="iconfont">&#xe614;</i>{{ memberMsg.integral }}<span>积分</span>
              </h1>
              <p>( 积分可抵扣{{ memberMsg.jifenMoeny }}元 )</p>
            </div>
          </div>
          <p v-if="jifenMsg.money!==0" class="tips">已抵扣{{ parseFloat(jifenMsg.money).toFixed(2) }}元</p>
        </li>
      </ul>
    </div>
    <el-dialog class="stage-coupon" width="820px" title="更多优惠券" :visible.sync="couponDialog" :append-to-body="true">
      <ul v-if="memberMsg.appointCardList" class="coupon-list ul" style="height: auto;">
        <li v-for="(item,index) in memberMsg.appointCardList" :key="index" @click="selectAppoint(item,index)">
          <div class="item" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_bg_color' : ''">
            <div :class="selectAppointIndex === index&&selectAppointFlag ? 'rightTopLabel_2' : 'rightTopLabel_1'">指定</div>
            <div v-if="item.cardType == 1" class="content" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_bd_color' : ''">
              <p class="contentOne" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_text_color' : ''">
                <span class="two-t" v-text="item.discount"></span>
                <span class="three-t">折</span>
                <span class="four-t" v-text="'×'+item.count"></span>
              </p>
              <p class="contentTwo" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_bgText_color' : ''">
                <samp>{{ item.title }}</samp>
                <el-popover class="item" placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                  <div class="couponTitle">{{ item.title }}</div>
                  <p class="couponP">使用范围：美业</p>
                  <p class="couponP">优惠券类型：{{ item.cardType == 1 ? '折扣券' : '代金券' }}</p>
                  <p class="couponP">优惠券详情：{{ item.couponDetail }}</p>
                  <p class="couponP">已开启功能：{{ item.openDetail }}</p>
                  <p class="couponP">有效期：{{ item.startTime }}至{{ item.endTime }}</p>
                  <i slot="reference" class="iconfont">&#xe71a;</i>
                </el-popover>
              </p>
              <label></label>
            </div>
            <div v-if="item.cardType == 2" class="content" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_bd_color' : ''">
              <p class="contentOne" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_text_color' : ''">
                <span class="one-t">￥</span>
                <span class="two-t" v-text="item.reduceCost"></span>
                <!-- <span class="three-t">免减券</span> -->
                <span class="four-t" v-text="'×'+item.count"></span>
              </p>
              <p class="contentTwo" :class="selectAppointIndex === index&&selectAppointFlag ? 'choose_bgText_color' : ''">
                <samp>{{ item.title }}</samp>
                <el-popover class="item" placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                  <div class="couponTitle">{{ item.title }}</div>
                  <p class="couponP">使用范围：美业</p>
                  <p class="couponP">优惠券类型：{{ item.cardType == 1 ? '折扣券' : '代金券' }}</p>
                  <p class="couponP">优惠券详情：{{ item.couponDetail }}</p>
                  <p class="couponP">已开启功能：{{ item.openDetail }}</p>
                  <p class="couponP">有效期：{{ item.startTime }}至{{ item.endTime }}</p>
                  <i slot="reference" class="iconfont">&#xe71a;</i>
                </el-popover>
              </p>
              <label></label>
            </div>
          </div>
          <div v-if="selectAppointIndex === index&&selectAppointFlag">
            <p class="tips">
              已选择
              <span v-text="'×'+hasSelectNumber"></span>
            </p>
          </div>
        </li>
      </ul>
      <ul v-if="memberMsg.cardList" class="coupon-list ul" style="height: auto;">
        <li v-for="(item,index) in memberMsg.cardList" :key="index" @click="selectCoupon(item,index)">
          <div class="item" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_bg_color' : ''">
            <div :class="selectCouponIndex === index&&selectCouponFlag ? 'rightTopLabel_2' : 'rightTopLabel_1'">通用</div>
            <div v-if="item.cardType == 1" class="content" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_bd_color' : ''">
              <p class="contentOne" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_text_color' : ''">
                <span class="two-t" v-text="item.discount"></span>
                <span class="three-t">折</span>
                <span class="four-t" v-text="'×'+item.count"></span>
              </p>
              <p class="contentTwo" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_bgText_color' : ''">
                <samp>{{ item.title }}</samp>
                <el-popover class="item" placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                  <div class="couponTitle">{{ item.title }}</div>
                  <p class="couponP">使用范围：全场通用</p>
                  <p class="couponP">优惠券类型：{{ item.cardType == 1 ? '折扣券' : '代金券' }}</p>
                  <p class="couponP">优惠券详情：{{ item.couponDetail }}</p>
                  <p class="couponP">已开启功能：{{ item.openDetail }}</p>
                  <p class="couponP">有效期：{{ item.startTime }}至{{ item.endTime }}</p>
                  <i slot="reference" class="iconfont">&#xe71a;</i>
                </el-popover>
              </p>
              <label></label>
            </div>
            <div v-if="item.cardType == 2" class="content" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_bd_color' : ''">
              <p class="contentOne" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_text_color' : ''">
                <span class="one-t">￥</span>
                <span class="two-t" v-text="item.reduceCost"></span>
                <!-- <span class="three-t">免减券</span> -->
                <span class="four-t" v-text="'×'+item.count"></span>
              </p>
              <p class="contentTwo" :class="selectCouponIndex === index&&selectCouponFlag ? 'choose_bgText_color' : ''">
                <samp>{{ item.title }}</samp>
                <el-popover class="item" placement="right" :trigger="uaValue === 'pc' ? 'hover' : 'click'">
                  <div class="couponTitle">{{ item.title }}</div>
                  <p class="couponP">使用范围：全场通用</p>
                  <p class="couponP">优惠券类型：{{ item.cardType == 1 ? '折扣券' : '代金券' }}</p>
                  <p class="couponP">优惠券详情：{{ item.couponDetail }}</p>
                  <p class="couponP">已开启功能：{{ item.openDetail }}</p>
                  <p class="couponP">有效期：{{ item.startTime }}至{{ item.endTime }}</p>
                  <i slot="reference" class="iconfont">&#xe71a;</i>
                </el-popover>
              </p>
              <label></label>
            </div>
          </div>
          <div v-if="selectCouponIndex === index&&selectCouponFlag">
            <p class="tips">
              已选择
              <span v-text="'×'+hasSelectNumber"></span>
            </p>
          </div>
        </li>
      </ul>
    </el-dialog>
    <!-- <div style="margin:10px 0" v-if="!memberMsg.fansCurrency &&memberMsg.integral ==0 &&!memberMsg.appointCardList &&!memberMsg.cardList">暂无优惠折扣~</div> -->
  </div>
</template>
<script>
/*
规则：
1.优先级：会员优惠>抵扣券、折扣卡>粉币+积分
2.discount:会员优惠
3.抵扣券、折扣卡使用规则：
    cardType:0, 卡券类型 0折扣券 1减免券
    addUser:是否允许叠加  0不允许 1已允许
    cashLeastCost:抵扣起始金额,
    discount ：折扣值
    reduceCost ：抵扣金额
    code：卡券code
    count：卡券数量
    reduceCost: 满cashLeastCost减免reduceCost

4.粉币使用规则：
    fansCurrency:当前粉币
    fenbiStartMoney：启兑金额
    fenbiRatio：兑换比例16.66:1
    fenbiMoeny:最多可兑换金额
5.积分使用规则：
    integral：当前积分
    jifenStartMoney：启兑金额
    jifenRatio：兑换比例2:1
    jifenMoeny:最多可兑换金额
6.备注：抵扣券、折扣卡只能选择其一 ，粉币和积分可同时使用
7.案例说明：
    1).订单金额 const total =  756
    2).会员优惠 6.7折
    3).抵扣券满50减10*5,addUser = 0/1
    4).折扣券:9折 * 5
    3).粉币3579个 兑换比例16.66:1 启兑换10
    4).积分5613分 兑换比例10:1 启兑换1
        a.会员优惠金额：const vipDiscount = 756*(1-0.67)
        b.优惠券抵扣金额:
            当前金额：const total2 = total - vipDiscount
            type1:抵扣券
                const maxUseNumber = addUser==1?((total2/cashLeastCost).toFixed(0)):1
                const coupon = maxUseNumber-count=>0?count*reduceCost:maxUseNumber*reduceCost
            type2:折扣券
                const maxUseNumber = 1
                const coupone = total2=>cashLeastCost?total2*(1-discount*0.1):0
        c.粉币抵扣金额：
            当前金额：const total3 = total2 - coupone
            const maxUsefans = total3%fenbiStartMoney==0?total3:( total3 - total3%fenbiStartMoney)
            const fans = maxUsefans=>fenbiMoeny?fenbiMoeny:maxUsefans
        d:积分抵扣金额：
            当前金额：const total4 = total3 - fans
            const maxUseJifen = total4%jifenStartMoney==0?total4:( total4 - total4%jifenStartMoney)
            const jifen = maxUseJifen=>jifenMoeny?jifenMoeny:maxUseJifen
        e:总的优惠金额：const lastTotal = total4 - jifen
*/
export default {
  props: {
    memberMsg: {
      type: Object,
      default: Object
    },
    totalMoney: {
      type: String,
      default: String
    },
    serviceItems: {
      type: Object,
      default() {
        return { serveItemsList: [], itemsSumTotal: '' };
      }
    },
    productSales: {
      type: Object,
      default() {
        return { productSalesList: [], productsSumTotal: 0 };
      }
    },
    bookAmount: {
      type: Number,
      default: Number
    },
    wholesalePrice: {
      type: Number,
      default: Number
    },
    packageBuy: {
      type: Number,
      default: Number
    }
  },
  data() {
    return {
      loading: true,
      selectCouponIndex: 0,
      selectCouponFlag: false,
      selectCouponChange: Date.parse(new Date()),
      selectFansCurrencyFlag: false,
      selectIntegralFlag: false,

      selectAppointIndex: 0,
      selectAppointFlag: false,
      hasSelectNumber: 1,
      couponMsg: {
        money: 0,
        num: 0,
        cardId: ''
      },
      fenBiMsg: {
        money: 0,
        num: 0
      },
      jifenMsg: {
        money: 0,
        num: 0
      },
      couponDialog: false,
      uaValue: 'pc', // 判断是手机端还是PC端   pc为PC端，mobile为手机端
    };
  },
  watch: {
    // 监听选择优惠券
    selectCouponChange() {
      this.initializeFansAndIntegral();
    },
  },
  activated() {
    this.selectCouponFlag = false;
    this.selectCouponIndex = 0;
    this.selectAppointFlag = false;
    this.selectAppointIndex = 0;
    this.selectFansCurrencyFlag = false;
    this.selectIntegralFlag = false;
    this.hasSelectNumber = 0;
    this.uaValue = this.Lib.pcOrMobile();
    this.couponMsg = {
      money: 0,
      num: 0,
      cardId: ''
    };
    this.fenBiMsg = {
      money: 0,
      num: 0
    };
    this.jifenMsg = {
      money: 0,
      num: 0
    };
  },
  methods: {
    // 选择通用优惠券
    selectCoupon(item, index) {
      if (!this.isCanSelectCoupon(item)) {
        return true;
      }
      this.cleanAppoint();
      this.selectAppointFlag = false;
      this.selectAppointIndex = 0;
      if (this.selectCouponIndex == index) {
        if (this.isCanSelectCoupon(item)) {
          this.selectCouponFlag = !this.selectCouponFlag && this.isCanSelectCoupon(item);
          if (!this.selectCouponFlag) {
            this.couponMsg = {
              money: '',
              num: ''
            };
          }
        } else {
          this.selectCouponFlag = false;
        }
      } else if (this.isCanSelectCoupon(item)) {
        this.selectCouponFlag = this.isCanSelectCoupon(item);
      }
      this.selectCouponIndex = index;
      this.selectCouponChange = Date.parse(new Date());
      this.$emit('getConponMsg', this.putParentData());
    },
    // 判断是否可以选择通用优惠券true/false
    isCanSelectCoupon(item) {
      const {
        cardType, addUser, addUseNumber, cashLeastCost, count, reduceCost, discount, limitDeduction, useCondition
      } = item;
      const total = (this.totalMoney * 1 - this.wholesalePrice * 1 - this.packageBuy * 1).toFixed(2);
      let maxUseNumber;
      let coupon;
      if (Number(cardType) === 2) { // 抵扣券
        if (Number(total) < Number(cashLeastCost) || (total * 1 == 0)) {
          this.$message('优惠不可用');
          return false;
        }
        // var newNum = (reduceCost * 1) >= (discount * 1) ? reduceCost : discount
        const newNum = (cashLeastCost * 1 > 0) ? cashLeastCost : 0.01;
        const newAun = addUseNumber * 1 == 0 ? count * 1 : addUseNumber * 1;
        const newMax = addUser == 1 ? parseInt(total / newNum, 10) > newAun ? newAun : parseInt(total / newNum, 10) : 1;
        maxUseNumber = newMax > 1 ? ((newMax * reduceCost - total * 1) > 0) ? (reduceCost * 1 - total * 1) == 0 ? 1 : (parseInt(total / reduceCost, 10) + 1) : newMax : 1;
        coupon = maxUseNumber - count >= 0 ? (count * reduceCost - total * 1) > 0 ? total * 1 : count * reduceCost : (maxUseNumber * reduceCost - total * 1) > 0 ? total * 1 : maxUseNumber * reduceCost;
      }
      if (Number(cardType) === 1) { // 折扣券
        console.log(total, useCondition);
        if (Number(total) < Number(useCondition) || (total * 1 == 0)) {
          this.$message('优惠不可用');
          return false;
        }
        maxUseNumber = 1;
        if (limitDeduction * 1 == 0) {
          coupon = total >= useCondition * 1 ? total * (1 - discount * 0.1) : 0;
        } else {
          coupon = total >= useCondition * 1 ? ((total * (1 - discount * 0.1) - limitDeduction * 1) > 0) ? limitDeduction : (total * (1 - discount * 0.1)) : 0;
        }
      }
      this.couponMsg = {
        money: (coupon * 1).toFixed(2),
        num: maxUseNumber - count >= 0 ? count : maxUseNumber,
        cardId: item.gid
      };
      this.hasSelectNumber = maxUseNumber - count >= 0 ? count : maxUseNumber;
      return true;
    },
    // 选择指定优惠券
    selectAppoint(item, index) {
      if (!this.isCanSelectAppoint(item)) {
        return true;
      }
      this.selectCouponFlag = false;
      this.selectCouponIndex = 0;
      if (this.selectAppointIndex == index) {
        this.selectAppointFlag = !this.selectAppointFlag;
        if (!this.selectAppointFlag) {
          this.couponMsg = {
            money: '',
            num: ''
          };
          this.cleanAppoint();
        }
      } else {
        this.selectAppointFlag = true;
      }
      this.selectAppointIndex = index;
      this.selectCouponChange = Date.parse(new Date());
      this.$emit('getConponMsg', this.putParentData());
    },
    // 清除选择指定券优惠价格数据
    cleanAppoint() {
      const vm = this;
      if (vm.serviceItems.serveItemsList) {
        vm.serviceItems.serveItemsList.forEach((item5) => {
          item5.newPrice = 0;
        });
      }
      if (vm.productSales.productSalesList) {
        vm.productSales.productSalesList.forEach((item6) => {
          item6.newPrice = 0;
        });
      }
    },
    // 判断是否可以选择指定优惠券true/false
    isCanSelectAppoint(item) {
      const vm = this;
      let sTotal = 0;
      let pTotal = 0;
      let maxUseNumber;
      let appoint;
      const {
        cardType, addUser, cashLeastCost, count, reduceCost, discount, limitDeduction, useCondition, useProductSet, useServeSet
      } = item;
      if (useServeSet) {
        useServeSet.forEach((item1) => {
          vm.serviceItems.serveItemsList.forEach((item2) => {
            if ((item1.id == item2.id) && !item2.orderItemDeduct) {
              sTotal += item2.resultPrice * 1;
            }
          });
        });
      }
      if (useProductSet) {
        useProductSet.forEach((item3) => {
          vm.productSales.productSalesList.forEach((item4) => {
            if (item3.productId == item4.productId) {
              if (item4.productDeduct) {
                pTotal += (item4.total * 1 - item4.discountMoney * item4.productDeduct.count);
              } else {
                pTotal += item4.total * 1;
              }
            }
          });
        });
      }
      const total = (sTotal * 1 + pTotal * 1 - this.bookAmount).toFixed(2);
      if (Number(total) < Number(cashLeastCost) || Number(total) < Number(reduceCost) || (total * 1 == 0)) {
        this.$message('优惠不可用');
        return false;
      }
      if (!useProductSet && !useServeSet) {
        this.$message('优惠不可用');
        return false;
      }

      if (useServeSet) {
        vm.serviceItems.serveItemsList.forEach((a) => {
          a.newPrice = 0;
        });
        useServeSet.forEach((item1) => {
          vm.serviceItems.serveItemsList.forEach((item2) => {
            if ((item1.id == item2.id) && !item2.orderItemDeduct) {
              item2.newPrice = 1;
            }
          });
        });
      }
      if (useProductSet) {
        vm.productSales.productSalesList.forEach((b) => {
          b.newPrice = 0;
        });
        useProductSet.forEach((item3) => {
          vm.productSales.productSalesList.forEach((item4) => {
            if (item3.productId == item4.productId) {
              if (item4.productDeduct) {
                item4.newPrice = 1;
              } else {
                item4.newPrice = 1;
              }
            }
          });
        });
      }

      if (Number(cardType) === 2) { // 抵扣券
        // var newNum = (reduceCost * 1) >= (discount * 1) ? reduceCost : discount
        const newNum = (cashLeastCost * 1 > 0) ? cashLeastCost : 0.01;
        const newMax = addUser == 1 ? (parseInt(total / newNum, 10)) : 1;
        maxUseNumber = newMax > 1 ? ((newMax * reduceCost - total * 1) > 0) ? (reduceCost * 1 - total * 1) == 0 ? 1 : (parseInt(total / reduceCost, 10) + 1) : newMax : 1;
        appoint = maxUseNumber - count >= 0 ? (count * reduceCost - total * 1) > 0 ? total * 1 : count * reduceCost : (maxUseNumber * reduceCost - total * 1) > 0 ? total * 1 : maxUseNumber * reduceCost;
      }
      // if (Number(cardType) === 2) { //抵扣券
      //     var newNum = (cashLeastCost * 1) >= (discount * 1) ? cashLeastCost : discount
      //     maxUseNumber = addUser == 1 ? (parseInt(total / newNum)) : 1
      //     appoint = maxUseNumber - count >= 0 ? count * reduceCost : maxUseNumber * reduceCost

      // }
      if (Number(cardType) === 1) { // 折扣券
        maxUseNumber = 1;
        if (limitDeduction * 1 == 0) {
          appoint = total >= useCondition * 1 ? total * (1 - discount * 0.1) : 0;
        } else {
          appoint = total >= useCondition * 1 ? ((total * (1 - discount * 0.1) - limitDeduction * 1) > 0) ? limitDeduction : (total * (1 - discount * 0.1)) : 0;
        }
      }
      if (vm.serviceItems.serveItemsList) {
        vm.serviceItems.serveItemsList.forEach((item5) => {
          if (item5.newPrice == 1) {
            item5.newPrice = (item5.resultPrice / total * appoint).toFixed(2);
          }
        });
      }
      if (vm.productSales.productSalesList) {
        vm.productSales.productSalesList.forEach((item6) => {
          if (item6.newPrice == 1) {
            if (item6.productDeduct) {
              (total && appoint) ? item6.newPrice = ((item6.total * 1 - item6.discountMoney * item6.productDeduct.count) / total * appoint).toFixed(2) : item6.newPrice = 0;
            } else {
              (total && appoint) ? item6.newPrice = (item6.total / total * appoint).toFixed(2) : item6.newPrice = 0;
            }
          }
        });
      }
      this.couponMsg = {
        money: (appoint * 1).toFixed(2),
        num: maxUseNumber - count >= 0 ? count : maxUseNumber,
        cardId: item.gid
      };
      this.hasSelectNumber = maxUseNumber - count >= 0 ? count : maxUseNumber;
      return true;
    },
    // 初始化粉币、积分
    initializeFansAndIntegral() {
      this.selectFansCurrencyFlag = false;
      this.selectIntegralFlag = false;
      this.fenBiMsg = { // 取消
        money: 0,
        num: 0
      };
      this.jifenMsg = { // 取消
        money: 0,
        num: 0
      };
      this.$emit('getConponMsg', this.putParentData());
    },
    // 选择粉币
    selectFansCurrency() {
      const { fenbiStartMoney, fenbiMoeny, fenbiRatio } = this.memberMsg;
      const total = this.getDicountMoney();
      if (total * 1 < fenbiStartMoney * 1 && !this.selectFansCurrencyFlag) {
        this.$message('粉币不可用');
        return false;
      }
      if (!this.selectFansCurrencyFlag) { // 选择
        const maxUsefans = total % Number(fenbiStartMoney) == 0 ? total : (total - total % Number(fenbiStartMoney));
        const fans = (maxUsefans * 1) >= (fenbiMoeny * 1) ? fenbiMoeny : maxUsefans;
        if (!Number(fans)) {
          this.$message('粉币不可用');
          return false;
        }
        this.fenBiMsg = {
          money: (fans * 1).toFixed(2),
          num: fans * fenbiRatio
        };
        this.selectFansCurrencyFlag = true;
      } else { // 取消
        this.selectFansCurrencyFlag = false;
        this.fenBiMsg = {
          money: 0,
          num: 0
        };
      }
      this.$emit('getConponMsg', this.putParentData());
    },
    // 选择积分
    selectIntegral() {
      const { jifenStartMoney, jifenMoeny, jifenRatio } = this.memberMsg;
      const total = this.getDicountMoney();
      if (jifenStartMoney * 1 > total * 1 && !this.selectIntegralFlag) {
        this.$message('积分不可用');
        return false;
      }
      if (!this.selectIntegralFlag) { // 选择
        let maxUseJifen;
        if (jifenStartMoney <= 0) {
          maxUseJifen = Math.floor(total * 1);
        } else {
          maxUseJifen = (total * 100) % 100 == 0 ? total : ((total * 100 - (total * 100 % 100)) / 100).toFixed(2);
        }
        const jifen = Number(maxUseJifen) >= Number(jifenMoeny) ? jifenMoeny : maxUseJifen;
        if (!Number(jifen)) {
          this.$message('积分不可用');
          return false;
        }
        this.jifenMsg = {
          money: (jifen * 1).toFixed(2),
          num: jifen * jifenRatio
        };
        this.selectIntegralFlag = true;
      } else { // 取消
        this.jifenMsg = {
          money: 0,
          num: 0
        };
        this.selectIntegralFlag = false;
      }
      this.$emit('getConponMsg', this.putParentData());
    },
    // 优惠后的金额
    getDicountMoney() {
      return ((this.totalMoney - this.couponMsg.money - this.jifenMsg.money - this.fenBiMsg.money - this.wholesalePrice - this.packageBuy) * 1).toFixed(2);
    },
    // 传递信息给父组件
    putParentData() {
      return {
        resulteMoney: window.JSON.parse(window.JSON.stringify((this.getDicountMoney() * 1 + this.wholesalePrice * 1).toFixed(2))),
        couponMsg: window.JSON.parse(window.JSON.stringify(this.couponMsg)),
        jifenMsg: window.JSON.parse(window.JSON.stringify(this.jifenMsg)),
        fenBiMsg: window.JSON.parse(window.JSON.stringify(this.fenBiMsg))
      };
    },
    // 打开选择更多优惠券窗口
    getMoreCoupon() {
      this.couponDialog = true;
    }
  }
};
</script>

<!-- 选择优惠券-->
<style lang="less" scoped>
.stage-coupon {
  .no-coupon {
    color: #999999;
    text-align: center;
    height: 123px;
    .icon-box {
      padding: 30px 0 15px 0;
    }
    .iconfont {
      font-size: 30px;
    }
  }
  font-size: 14px;
  .ul {
    list-style-type: none;
  }
  .new-coupon-list {
    overflow: hidden;
    list-style-type: none;
    li {
      position: relative;
      overflow: hidden;
      padding: 5px 13px;
      min-width: 182px;
      height: 90px;
      float: left;
      background-color: #e9f4ff;
      box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
      margin-right: 12px;
      margin-bottom: 20px;
      .item {
        min-width: 182px;
        min-height: 90px;
        border-radius: 8px;
        border: dashed 1px #409eff;
      }
    }
  }
  .moreCoupon {
    position: absolute;
    cursor: pointer;
    top: 76px;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
  }
  .coupon-list {
    overflow: hidden;
    height: 111px;
    display: contents;
    li {
      position: relative;
      overflow: hidden;
      height: 101px;
      min-width: 160px;
      float: left;
      margin-right: 20px;
      margin-bottom: 10px;
      .item {
        min-width: 160px;
        height: 76px;
        border-radius: 10px;
        cursor: pointer;
        overflow: hidden;
        font-size: 14px;
        .rightTopLabel_1 {
          padding-right: 5px;
          color: #fff;
          height: 25px;
          width: 67px;
          position: absolute;
          right: -25px;
          font-size: 12px;
          text-align: center;
          line-height: 30px;
          opacity: 0.7;
          -moz-transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          -o-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
        }
        .rightTopLabel_2 {
          padding-right: 5px;
          height: 25px;
          width: 67px;
          position: absolute;
          right: -25px;
          font-size: 12px;
          text-align: center;
          line-height: 30px;
          opacity: 0.7;
          -moz-transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          -o-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
        }
        .content {
          height: 64px;
          border-radius: 8px;
          margin: 5px 9px;
          label {
            position: absolute;
            left: -60px;
            top: -42px;
            height: 78px;
            min-width: 300px;
            width: auto;
            background-color: rgba(255, 255, 255, 0.3);
            transform: rotate(-30deg);
          }
          .contentOne {
            height: 37px;
            padding: 0 10px;
            line-height: 37px;
            .one-t {
              position: relative;
              top: 4px;
              font-size: 14px;
              float: left;
            }
            .two-t {
              font-size: 24px;
            }
            .three-t {
              position: relative;
              top: -2px;
              font-size: 14px;
            }
            .four-t {
              position: relative;
              top: -6px;
              font-size: 14px;
              float: right;
              padding-right: 10px;
            }
          }
          .choose_text_color {
            color: #fff;
          }
          .choose_bgText_color {
            color: #fff;
          }
        }
        .contentTwo {
          margin: 0 10px;
          height: 22px;
          border-radius: 4px;
          font-size: 12px;
          line-height: 22px;
          width: 120px;
          samp {
            max-width: 102px;
            float: left;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          i {
            width: 18px;
            text-align: right;
            float: left;
            font-size: 12px;
            position: relative;
            z-index: 2;
          }
        }
        .content-t1 {
          font-size: 23px;
        }
        .content-t2 {
          font-size: 13px;
          span {
            margin-left: 35px;
          }
        }
      }
      .item:before,
      .item:after {
        content: " ";
        width: 0;
        height: 68%;
        position: absolute;
        top: 8px;
      }
      .item:before {
        border-right: 8px dotted white;
        left: -4px;
      }

      .item:after {
        border-left: 8px dotted white;
        right: -4px;
      }
      .tips {
        font-size: 13px;
        height: 25px;
        line-height: 25px;
        text-align: right;
      }
      .bot {
        position: absolute;
        top: 38px;
        display: block;
        width: 20px;
        height: 20px;
        border-radius: 100%;
        background-color: #fff;
        z-index: 9;
      }
      .bot1 {
        left: -10px;
      }
      .bot2 {
        right: -10px;
      }
      .active {
        .item {
          color: #ffffff;
        }
      }
    }
  }
  .card-list {
    overflow: hidden;
    height: 100px;
    li {
      position: relative;
      overflow: hidden;
      height: 100px;
      min-width: 158px;
      float: left;
      margin-right: 20px;
      .content {
        padding: 0 14px;
        min-width: 130px;
        height: 74px;
        background-color: #fff;
        border-radius: 8px;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        .detail {
          padding: 5px 0;
          h1 {
            height: 36px;
            line-height: 36px;
            font-size: 24px;
            span {
              position: relative;
              font-size: 14px;
            }
            i {
              font-size: 16px;
              line-height: 36px;
              padding-right: 5px;
            }
          }
          p {
            height: 28px;
            line-height: 28px;
            font-size: 13px;
          }
        }
      }
    }
    .avtive {
      color: #ffffff;
    }
    .tips {
      font-size: 13px;
      height: 25px;
      line-height: 25px;
      text-align: right;
    }
  }
}
.el-tooltip__popper p {
  height: 20px;
  line-height: 20px;
}
.N_box {
  // display: flex;
  height: 110px;
  overflow: hidden;
  position: relative;
}
</style>
